/* Core & libraries */
import React from "react";

/* Helpers, constants, custom methods, internal libraries */
import { useUserContext } from "../contexts/userContext";

/* Components */
/* Styles */

export const useHasPermission = () => {
  const userContext = useUserContext();
  const userPermission = userContext?.userInfo?.permissions;

  const checkPermission = (allowedPermissions) => {
    return userPermission && userPermission.includes(allowedPermissions);
  }

  return {
    checkPermission
  }
}

